const DEFAULT_GOOGLE_MAPS_KEY = 'AIzaSyBsKhwXHQQizvKzFNSF33zMJsfgNKvjB2Y';
export default class Fingerprint {
    public static getBackendInfo = (useGeoPosition: boolean) => {
        let def = $.Deferred();

        function getLocation(useGeoPosition: boolean) {
            // Если геолокация поддерживается браузером, и нам это реально надо
            // мб опция позже (переписка с Лео от 6.08.2024)
            if (useGeoPosition && navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(showPosition, failGetLocation);
            } else {
                failGetLocation();
            }
        }

        function failGetLocation() {
            showPosition(null);
        }

        function showPosition(position) {
            //const isMobile = () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            //let DeviceType = (isMobile() ? 'Mobile' : 'Desktop')
            const devname = navigator?.userAgent.split('(')[1].split(')')[0] || 'unknown';

            if (position) {
                var lat = position.coords.latitude;
                var lon = position.coords.longitude;
                $.when(
                    $.getJSON(
                        'https://maps.googleapis.com/maps/api/geocode/json?latlng=' +
                            lat +
                            ',' +
                            lon +
                            '&key=' +
                            DEFAULT_GOOGLE_MAPS_KEY
                    )
                        .then((data) => {
                            var location = data.plus_code.compound_code;
                            if (location && location.length > 0 && location.split(' ').length > 2) {
                                var location = location.split(' ').slice(1).join(' ');
                            }
                            let backenInfo =
                                'Device Information: ' +
                                devname +
                                '; ' +
                                //'IP address: ' + ip + '; ' +
                                'Location: ' +
                                location +
                                '; ' +
                                'Browser: ' +
                                Fingerprint.currDeviceNameVersion();
                            def.resolve(backenInfo);
                        })
                        .fail(() => {
                            let backenInfo =
                                'Device Information: ' +
                                devname +
                                '; ' +
                                //'IP address: ' + ip + '; ' +
                                'Browser: ' +
                                Fingerprint.currDeviceNameVersion();
                            def.resolve(backenInfo);
                        })
                );
            } else {
                let backenInfo =
                    'Device Information: ' +
                    devname +
                    '; ' +
                    //'IP address: ' + ip + '; ' +
                    'Browser: ' +
                    Fingerprint.currDeviceNameVersion();
                def.resolve(backenInfo);
            }
        }
        getLocation(useGeoPosition);

        return def;
    };

    public static getFingerPrint = () => {
        return Fingerprint.x64hash128(JSON.stringify(Fingerprint.browserInfo()));
    };

    public static isInternal = () => {
        var n: any = navigator;
        if (n.userAgentData != null && n.userAgentData.brands != null) {
            let brands = n.userAgentData.brands;
            for (let i = 0; i < brands.length; i++) {
                if (brands[i].brand === 'Microsoft Edge WebView2') {
                    return true;
                }
            }
            return false;
        } else {
            return false;
        }
    };

    public static getOS() {
        var os = navigator?.userAgent.split('(')[1].split(')')[0] || 'unknown';
        var nAgt = navigator.userAgent;
        var clientStrings = [
            { s: 'Windows 10', r: /(Windows 10.0|Windows NT 10.0)/ },
            { s: 'Windows 8.1', r: /(Windows 8.1|Windows NT 6.3)/ },
            { s: 'Windows 8', r: /(Windows 8|Windows NT 6.2)/ },
            { s: 'Windows 7', r: /(Windows 7|Windows NT 6.1)/ },
            { s: 'Windows Vista', r: /Windows NT 6.0/ },
            { s: 'Windows Server 2003', r: /Windows NT 5.2/ },
            { s: 'Windows XP', r: /(Windows NT 5.1|Windows XP)/ },
            { s: 'Windows 2000', r: /(Windows NT 5.0|Windows 2000)/ },
            { s: 'Windows ME', r: /(Win 9x 4.90|Windows ME)/ },
            { s: 'Windows 98', r: /(Windows 98|Win98)/ },
            { s: 'Windows 95', r: /(Windows 95|Win95|Windows_95)/ },
            { s: 'Windows NT 4.0', r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/ },
            { s: 'Windows CE', r: /Windows CE/ },
            { s: 'Windows 3.11', r: /Win16/ },
            { s: 'Android', r: /Android/ },
            { s: 'Open BSD', r: /OpenBSD/ },
            { s: 'Sun OS', r: /SunOS/ },
            { s: 'Linux', r: /(Linux|X11)/ },
            { s: 'webOS', r: /(webOS)/ },
            { s: 'BlackBerry', r: /(BlackBerry)/ },
            { s: 'IEMobile', r: /(IEMobile)/ },
            { s: 'Opera Mini', r: /(Opera Mini)/ },
            { s: 'iPhone iOS', r: /(iPhone)/ },
            { s: 'iPad iOS', r: /(iPad)/ },
            { s: 'iPod iOS', r: /(iPod)/ },
            { s: 'Mac OS X', r: /Mac OS X/ },
            { s: 'Mac OS', r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/ },
            { s: 'QNX', r: /QNX/ },
            { s: 'UNIX', r: /UNIX/ },
            { s: 'BeOS', r: /BeOS/ },
            { s: 'OS/2', r: /OS\/2/ },
            { s: 'Search Bot', r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/ }
        ];
        for (var id in clientStrings) {
            var cs = clientStrings[id];
            if (cs.r.test(nAgt)) {
                os = cs.s;
                break;
            }
        }
        return os;
    }

    public static currDeviceNameVersion() {
        var ua = navigator.userAgent;
        var tem;
        var M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            return 'IE ' + (tem[1] || '');
        }
        if (M[1] === 'Chrome') {
            tem = ua.match(/\b(OPR)\/(\d+)/);
            if (tem != null) return 'Opera ' + tem.slice(1)[1];
            tem = ua.match(/\b(Edg[a-zA-Z]{0,3})\/(\d+)/);
            if (tem != null) return 'Edge ' + tem.slice(1)[1];
        } else if (M[1] === 'Safari') {
            tem = ua.match(/\b(EdgiOS)\/(\d+)/);
            if (tem != null) return 'Edge ' + tem.slice(1)[1];
            tem = ua.match(/\b(FxiOS)\/(\d+)/);
            if (tem != null) return 'Firefox ' + tem.slice(1)[1];
            tem = ua.match(/\b(CriOS)\/(\d+)/);
            if (tem != null) return 'Chrome ' + tem.slice(1)[1];
        }
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
        if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
        return M.join(' ');
    }

    public static currDeviceName() {
        var d: any = document;
        if ((navigator.userAgent.indexOf('Opera') || navigator.userAgent.indexOf('OPR')) !== -1) {
            return 'Opera';
        } else if (navigator.userAgent.indexOf('Edg') !== -1) {
            return 'Edge';
        } else if (navigator.userAgent.indexOf('Chrome') !== -1) {
            return 'Chrome';
        } else if (navigator.userAgent.indexOf('Safari') !== -1) {
            return 'Safari';
        } else if (navigator.userAgent.indexOf('Firefox') !== -1) {
            return 'Firefox';
        } else if (navigator.userAgent.indexOf('MSIE') !== -1 || !!d.documentMode === true) {
            //IF IE > 10
            return 'IE';
        } else {
            return 'unknown';
        }
    }

    private static browserInfo() {
        return {
            user_agent: Fingerprint.currDeviceName(),
            cookies_enabled: Fingerprint.cookiesEnabled(),
            java_enabled: Fingerprint.javaEnabled(),
            language: Fingerprint.language(),
            plugins: Fingerprint.plugins(),
            timezone: Fingerprint.timezone(),
            timezone_offset: Fingerprint.timezoneOffset(),
            do_not_track: Fingerprint.doNotTrack(),
            platform: Fingerprint.platform(),
            geo_supported: Fingerprint.geoSupported(),
            //screen_width: Fingerprint.screenWidth(), IL: If you use second monitor, pinger print will change
            //screen_height: Fingerprint.screenHeight(),
            //screen_depth: Fingerprint.screenDepth(),
            logical_cores: Fingerprint.logicalCores()
        };
    }

    private static cookiesEnabled(): boolean {
        return navigator.cookieEnabled;
    }

    private static language(): string {
        return navigator.language;
    }

    private static plugins(): string[] {
        var p: any = navigator.plugins;
        if (!p) return [];

        const res: string[] = [];
        for (let i = 0; i < p.length; i++) {
            res.push(p[i].name);
        }

        return res;
    }

    private static timezone(): string {
        if (!window.Intl || !window.Intl.DateTimeFormat) {
            return '';
        }
        return window.Intl.DateTimeFormat().resolvedOptions().timeZone;
    }

    private static timezoneOffset(): number {
        return new Date().getTimezoneOffset();
    }

    private static doNotTrack(): boolean {
        if (navigator.doNotTrack !== undefined) {
            return navigator.doNotTrack === 'yes';
        }
        let w: any = window;
        if (w.doNotTrack !== undefined) {
            return w.doNotTrack === 'yes';
        }
        return false;
    }

    private static platform(): string {
        return navigator.platform;
    }

    private static screenDepth(): number {
        return window.screen.colorDepth;
    }

    private static geoSupported(): boolean {
        return navigator.geolocation !== undefined;
    }

    private static screenWidth(): number {
        return window.screen.width;
    }

    private static screenHeight(): number {
        return window.screen.height;
    }

    private static logicalCores(): number {
        return navigator.hardwareConcurrency;
    }

    private static javaEnabled(): boolean {
        if (!navigator.javaEnabled) {
            return false;
        }
        return navigator.javaEnabled();
    }

    private static x64Multiply(m: number[], n: number[]) {
        m = [m[0] >>> 16, m[0] & 0xffff, m[1] >>> 16, m[1] & 0xffff];
        n = [n[0] >>> 16, n[0] & 0xffff, n[1] >>> 16, n[1] & 0xffff];
        const o = [0, 0, 0, 0];
        o[3] += m[3] * n[3];
        o[2] += o[3] >>> 16;
        o[3] &= 0xffff;
        o[2] += m[2] * n[3];
        o[1] += o[2] >>> 16;
        o[2] &= 0xffff;
        o[2] += m[3] * n[2];
        o[1] += o[2] >>> 16;
        o[2] &= 0xffff;
        o[1] += m[1] * n[3];
        o[0] += o[1] >>> 16;
        o[1] &= 0xffff;
        o[1] += m[2] * n[2];
        o[0] += o[1] >>> 16;
        o[1] &= 0xffff;
        o[1] += m[3] * n[1];
        o[0] += o[1] >>> 16;
        o[1] &= 0xffff;
        o[0] += m[0] * n[3] + m[1] * n[2] + m[2] * n[1] + m[3] * n[0];
        o[0] &= 0xffff;
        return [(o[0] << 16) | o[1], (o[2] << 16) | o[3]];
    }

    private static x64Rotl(m: number[], n: number) {
        n %= 64;
        if (n === 32) {
            return [m[1], m[0]];
        } else if (n < 32) {
            return [(m[0] << n) | (m[1] >>> (32 - n)), (m[1] << n) | (m[0] >>> (32 - n))];
        } else {
            n -= 32;
            return [(m[1] << n) | (m[0] >>> (32 - n)), (m[0] << n) | (m[1] >>> (32 - n))];
        }
    }

    private static x64Add(m: number[], n: number[]) {
        m = [m[0] >>> 16, m[0] & 0xffff, m[1] >>> 16, m[1] & 0xffff];
        n = [n[0] >>> 16, n[0] & 0xffff, n[1] >>> 16, n[1] & 0xffff];
        const o = [0, 0, 0, 0];
        o[3] += m[3] + n[3];
        o[2] += o[3] >>> 16;
        o[3] &= 0xffff;
        o[2] += m[2] + n[2];
        o[1] += o[2] >>> 16;
        o[2] &= 0xffff;
        o[1] += m[1] + n[1];
        o[0] += o[1] >>> 16;
        o[1] &= 0xffff;
        o[0] += m[0] + n[0];
        o[0] &= 0xffff;
        return [(o[0] << 16) | o[1], (o[2] << 16) | o[3]];
    }

    private static x64Xor(m: number[], n: number[]) {
        return [m[0] ^ n[0], m[1] ^ n[1]];
    }

    private static x64LeftShift(m: number[], n: number) {
        n %= 64;
        if (n === 0) {
            return m;
        } else if (n < 32) {
            return [(m[0] << n) | (m[1] >>> (32 - n)), m[1] << n];
        } else {
            return [m[1] << (n - 32), 0];
        }
    }

    private static x64Fmix(h: number[]) {
        h = Fingerprint.x64Xor(h, [0, h[0] >>> 1]);
        h = Fingerprint.x64Multiply(h, [0xff51afd7, 0xed558ccd]);
        h = Fingerprint.x64Xor(h, [0, h[0] >>> 1]);
        h = Fingerprint.x64Multiply(h, [0xc4ceb9fe, 0x1a85ec53]);
        h = Fingerprint.x64Xor(h, [0, h[0] >>> 1]);
        return h;
    }

    private static x64hash128(key: string, seed?: number): string {
        key = key || '';
        seed = seed || 0;
        const remainder = key.length % 16;
        const bytes = key.length - remainder;
        let h1 = [0, seed];
        let h2 = [0, seed];
        let k1 = [0, 0];
        let k2 = [0, 0];
        const c1 = [0x87c37b91, 0x114253d5];
        const c2 = [0x4cf5ad43, 0x2745937f];
        let i: number;
        for (i = 0; i < bytes; i = i + 16) {
            k1 = [
                (key.charCodeAt(i + 4) & 0xff) |
                    ((key.charCodeAt(i + 5) & 0xff) << 8) |
                    ((key.charCodeAt(i + 6) & 0xff) << 16) |
                    ((key.charCodeAt(i + 7) & 0xff) << 24),
                (key.charCodeAt(i) & 0xff) |
                    ((key.charCodeAt(i + 1) & 0xff) << 8) |
                    ((key.charCodeAt(i + 2) & 0xff) << 16) |
                    ((key.charCodeAt(i + 3) & 0xff) << 24)
            ];
            k2 = [
                (key.charCodeAt(i + 12) & 0xff) |
                    ((key.charCodeAt(i + 13) & 0xff) << 8) |
                    ((key.charCodeAt(i + 14) & 0xff) << 16) |
                    ((key.charCodeAt(i + 15) & 0xff) << 24),
                (key.charCodeAt(i + 8) & 0xff) |
                    ((key.charCodeAt(i + 9) & 0xff) << 8) |
                    ((key.charCodeAt(i + 10) & 0xff) << 16) |
                    ((key.charCodeAt(i + 11) & 0xff) << 24)
            ];
            k1 = Fingerprint.x64Multiply(k1, c1);
            k1 = Fingerprint.x64Rotl(k1, 31);
            k1 = Fingerprint.x64Multiply(k1, c2);
            h1 = Fingerprint.x64Xor(h1, k1);
            h1 = Fingerprint.x64Rotl(h1, 27);
            h1 = Fingerprint.x64Add(h1, h2);
            h1 = Fingerprint.x64Add(Fingerprint.x64Multiply(h1, [0, 5]), [0, 0x52dce729]);
            k2 = Fingerprint.x64Multiply(k2, c2);
            k2 = Fingerprint.x64Rotl(k2, 33);
            k2 = Fingerprint.x64Multiply(k2, c1);
            h2 = Fingerprint.x64Xor(h2, k2);
            h2 = Fingerprint.x64Rotl(h2, 31);
            h2 = Fingerprint.x64Add(h2, h1);
            h2 = Fingerprint.x64Add(Fingerprint.x64Multiply(h2, [0, 5]), [0, 0x38495ab5]);
        }
        k1 = [0, 0];
        k2 = [0, 0];
        switch (remainder) {
            case 15:
                k2 = Fingerprint.x64Xor(k2, Fingerprint.x64LeftShift([0, key.charCodeAt(i + 14)], 48));
            // fallthrough
            case 14:
                k2 = Fingerprint.x64Xor(k2, Fingerprint.x64LeftShift([0, key.charCodeAt(i + 13)], 40));
            // fallthrough
            case 13:
                k2 = Fingerprint.x64Xor(k2, Fingerprint.x64LeftShift([0, key.charCodeAt(i + 12)], 32));
            // fallthrough
            case 12:
                k2 = Fingerprint.x64Xor(k2, Fingerprint.x64LeftShift([0, key.charCodeAt(i + 11)], 24));
            // fallthrough
            case 11:
                k2 = Fingerprint.x64Xor(k2, Fingerprint.x64LeftShift([0, key.charCodeAt(i + 10)], 16));
            // fallthrough
            case 10:
                k2 = Fingerprint.x64Xor(k2, Fingerprint.x64LeftShift([0, key.charCodeAt(i + 9)], 8));
            // fallthrough
            case 9:
                k2 = Fingerprint.x64Xor(k2, [0, key.charCodeAt(i + 8)]);
                k2 = Fingerprint.x64Multiply(k2, c2);
                k2 = Fingerprint.x64Rotl(k2, 33);
                k2 = Fingerprint.x64Multiply(k2, c1);
                h2 = Fingerprint.x64Xor(h2, k2);
            // fallthrough
            case 8:
                k1 = Fingerprint.x64Xor(k1, Fingerprint.x64LeftShift([0, key.charCodeAt(i + 7)], 56));
            // fallthrough
            case 7:
                k1 = Fingerprint.x64Xor(k1, Fingerprint.x64LeftShift([0, key.charCodeAt(i + 6)], 48));
            // fallthrough
            case 6:
                k1 = Fingerprint.x64Xor(k1, Fingerprint.x64LeftShift([0, key.charCodeAt(i + 5)], 40));
            // fallthrough
            case 5:
                k1 = Fingerprint.x64Xor(k1, Fingerprint.x64LeftShift([0, key.charCodeAt(i + 4)], 32));
            // fallthrough
            case 4:
                k1 = Fingerprint.x64Xor(k1, Fingerprint.x64LeftShift([0, key.charCodeAt(i + 3)], 24));
            // fallthrough
            case 3:
                k1 = Fingerprint.x64Xor(k1, Fingerprint.x64LeftShift([0, key.charCodeAt(i + 2)], 16));
            // fallthrough
            case 2:
                k1 = Fingerprint.x64Xor(k1, Fingerprint.x64LeftShift([0, key.charCodeAt(i + 1)], 8));
            // fallthrough
            case 1:
                k1 = Fingerprint.x64Xor(k1, [0, key.charCodeAt(i)]);
                k1 = Fingerprint.x64Multiply(k1, c1);
                k1 = Fingerprint.x64Rotl(k1, 31);
                k1 = Fingerprint.x64Multiply(k1, c2);
                h1 = Fingerprint.x64Xor(h1, k1);
            // fallthrough
        }
        h1 = Fingerprint.x64Xor(h1, [0, key.length]);
        h2 = Fingerprint.x64Xor(h2, [0, key.length]);
        h1 = Fingerprint.x64Add(h1, h2);
        h2 = Fingerprint.x64Add(h2, h1);
        h1 = Fingerprint.x64Fmix(h1);
        h2 = Fingerprint.x64Fmix(h2);
        h1 = Fingerprint.x64Add(h1, h2);
        h2 = Fingerprint.x64Add(h2, h1);
        return (
            ('00000000' + (h1[0] >>> 0).toString(16)).slice(-8) +
            ('00000000' + (h1[1] >>> 0).toString(16)).slice(-8) +
            ('00000000' + (h2[0] >>> 0).toString(16)).slice(-8) +
            ('00000000' + (h2[1] >>> 0).toString(16)).slice(-8)
        );
    }
}

